// extracted by mini-css-extract-plugin
export var cardLayout = "_8w-1";
export var paginationContainer = "_8w-0";